import { App } from "./App_";

const myApp = new App();
if (module && module.hot) {
  module.hot.dispose(() => {
    if (myApp) myApp.dispose();
  });
}


